import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import MultiLineEllipsis from '../../../../elements/MultiLineEllipsis/MultiLineEllipsis';
import { Issue } from '../../types/issues-types';
import { generateIcons } from '../../utils/issue-utils';

const IssueCategoryCell: FC<
  React.PropsWithChildren<IssueCategoryCellProps>
> = ({ issue }) => {
  const { classes } = useStyles();
  const { CategoryIcon } = generateIcons(issue.category);

  return (
    <div className={classes.category}>
      {CategoryIcon && <CategoryIcon className={classes.categoryIcon} />}
      <MultiLineEllipsis lines={2} variant='body2'>
        {issue.category}
      </MultiLineEllipsis>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  category: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  categoryIcon: {
    width: '1rem',
    height: '1rem',
    maxWidth: 20,
    maxHeight: 20,
    flexShrink: 0,
    color: theme.palette.primary.main,
  },
}));

export interface IssueCategoryCellProps {
  issue: Issue;
}

export default IssueCategoryCell;
